import request from '@/utils/request'

let License_plate_classificationApi = {

  /*牌照分类列表*/
  list(data) {
    return request._post('/shop/plus.license_plate_classification.Index/index', data);
},
/*添加牌照分类*/
add(data) {
    return request._post('/shop/plus.license_plate_classification.Index/add', data);
},
/*修改牌照分类*/
edit(data) {
    return request._post('/shop/plus.license_plate_classification.Index/edit', data);
},
/*删除牌照分类*/
del(data) {
    return request._post('/shop/plus.license_plate_classification.Index/del', data);
},
/*牌照分类详情*/
detail(data) {
  return request._post('/shop/plus.license_plate_classification.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.license_plate_classification.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.license_plate_classification.Setting/getSetting', data, errorback);
    },
}
export default License_plate_classificationApi;



// WEBPACK FOOTER //
// ./src/api/license_plate_classification.js